import AgentActivity from 'models/agent_activity';
import ChannelsAdmin from 'models/location/channels_admin';
import changeCurrentLocation from 'actions/lib/change_current_location';
import FetchIvrs from 'actions/ivr/fetch_ivrs';
import SetAndLogActivity from 'actions/agent_activity/set_and_log_activity';

export default class OpenChannelsAdmin {
  constructor(context) {
    this.context = context;
  }

  run({ section } = {}) {
    const appFeatures = this.context.stores.appFeatures.get();

    if (!appFeatures.isEnabled('channelManagement')) {
      this.context.router.navigateHome();
      return;
    }

    changeCurrentLocation(this.context, ChannelsAdmin.create({ section }));

    this.context.executeAction(FetchIvrs);
    this.context.executeAction(SetAndLogActivity, { type: AgentActivity.Type.CHANNELS_ADMIN });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/channels/open_channels_admin.js